export const d_dateFormat = {
  standardFormat: "yyyy/MM/dd hh:mm:ss",
  shortDate: "yyyy/MM/dd",
  shortTime: "hh:mm:ss",
}

const weekdayStr = [
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];

export const d_getWeekday = () => {
  let weekday = new Date().getDay();
  return weekdayStr[weekday];
};

export const d_getWeekDates = (isUTC = false) => {
  let weekDates = [];
  let now = new Date();
  now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (isUTC) {
    now = d_toUTCDate(now);
  }
  weekDates.push(now);

  let weekday = new Date().getDay();
  if (weekday == 0) {
    for (let i = 1; i < 7; i++) {
      let newDate = new Date();
      newDate.setTime(now.getTime());
      newDate.setDate(now.getDate() - i);
      weekDates.unshift(newDate);
    }
  } else {
    for (let i = 1; i <= 7 - weekday; i++) {
      let newDate = new Date();
      newDate.setTime(now.getTime());
      newDate.setDate(now.getDate() + i);
      weekDates.push(newDate);
    }

    for (let i = 1; i < weekday; i++) {
      let newDate = new Date();
      newDate.setTime(now.getTime());
      newDate.setDate(now.getDate() - i);
      weekDates.unshift(newDate);
    }
  }
  return weekDates;
};

export const d_getShortDateString = () => {
  var date = new Date(); //创建日期对象
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return year + "年" + month + "月" + day + "日";
};

/**
 * 通用日期格式化
 * @author ckk
 * @param date
 * @param format 如："yyyy/MM/dd"、"yyyy-MM-dd hh:mm:ss"、"yyyy年MM月dd日"、"yyyy-MM-dd"等等
 * @returns {*}
 */
 export function d_dateStringWithFormat(date, format) {
  var obj = {
    "M+": date.getMonth() + 1, // 月
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var i in obj) {
    if (new RegExp("(" + i + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? obj[i]
          : ("00" + obj[i]).substr(("" + obj[i]).length)
      );
    }
  }
  return format;
}

export function d_utcDate() {
  var date1 = new Date();
  return d_toUTCDate(date1);
}

export function d_utcDateString() {
  return d_dateStringWithFormat(d_utcDate(), d_dateFormat.standardFormat);
}

export function d_localDateString() {
  return d_dateStringWithFormat(new Date(), d_dateFormat.standardFormat);
}

export function d_toUTCDate(localDate) {
  var offsetMinute = localDate.getTimezoneOffset();
  var offsetHours = offsetMinute / 60;
  localDate.setHours(localDate.getHours() + offsetHours);
  return localDate;
}

export function d_toUtcDateStringFromLocalDateString(localDateString) {
  var localDate = new Date(localDateString);
  var utcDate = d_toUTCDate(localDate);
  return d_dateStringWithFormat(utcDate, d_dateFormat.standardFormat);
}

export function d_toLocalDateFromUtcStr(dateStr) {
  var dateLocal = new Date();
  var offsetMinute = dateLocal.getTimezoneOffset();
  var offsetHours = offsetMinute / 60;
  var dateUtc = new Date(dateStr);
  dateUtc.setHours(dateUtc.getHours() - offsetHours);
  return dateUtc;
}

export function d_toLocalDateStandardFormatStr(utcDateStr) {
  return d_dateStringWithFormat(d_toLocalDateFromUtcStr(utcDateStr), d_dateFormat.standardFormat);
}

// compare date object
// 0：相等，-1：小于，1：大于
export function d_compareDate(date1, date2) {
  if (date1.getTime() < date2.getTime()) {
    return -1;
  } else if (date1.getTime() > date2.getTime()) {
    return 1;
  } else {
    return 0;
  }
}

// compare date string
// 0：相等，-1：小于，1：大于
export function d_compareDateString(date1Str, date2Str) {
  var date1 = new Date(date1Str);
  var date2 = new Date(date2Str);
  return d_compareDate(date1, date2);
}

export function d_toLocalDateStringMsgFormat(utcDateStr) {
  var localDate = d_toLocalDateFromUtcStr(utcDateStr);
  var localYear = localDate.getFullYear();
  var localMonth = localDate.getMonth() + 1;
  var localDay = localDate.getDate();
  var localHour = localDate.getHours();
  var localMinute = localDate.getMinutes();
  // var localSecond = localDate.getSeconds();

  var curDate = new Date();
  var curYear = curDate.getFullYear();
  var curMonth = curDate.getMonth() + 1;
  var curDay = curDate.getDate();
  // var curHour = curDate.getHours();
  // var curMinute = curDate.getMinutes();
  // var curSecond = curDate.getSeconds();

  if (localYear < curYear) {
		return localYear + "年" + formatNumber(localMonth) + "月" + formatNumber(localDay) + "日";
	}
   else if (localYear == curYear && localMonth < curMonth) {
		return formatNumber(localMonth) + "月" + formatNumber(localDay) + "日";
	}
   else if (localYear == curYear && localMonth == curMonth && localDay < curDay) {
		return formatNumber(localMonth) + "月" + formatNumber(localDay) + "日";
	}
   else if (localYear == curYear && localMonth == curMonth && localDay == curDay) {
		return getSlot(localHour) + " " + formatNumber(localHour) + ":" + formatNumber(localMinute);

	} else {
		return localYear + "年" + formatNumber(localMonth) + "月" + formatNumber(localDay) + "日";
	}
}

// 辅助方法
const getSlot = hours => {
	if (0 <= hours && hours <= 5)
		return "凌晨";
	else if (6 <= hours && hours <= 9)
		return "早上";
	else if (10 <= hours && hours <= 11)
		return "上午";
	else if (hours == 12)
		return "中午";
	else if (13 <= hours && hours <= 17)
		return "下午";
	else return "晚上";
}
// 辅助方法
const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}

export default {
  d_dateFormat,
  d_getWeekday,
  d_getWeekDates,
  d_getShortDateString,
  d_dateStringWithFormat,
  d_utcDate,
  d_toUTCDate,
  d_utcDateString,
  d_localDateString,
  d_toUtcDateStringFromLocalDateString,
  d_toLocalDateFromUtcStr,
  d_toLocalDateStandardFormatStr,
  d_toLocalDateStringMsgFormat,
  d_compareDate,
  d_compareDateString,
};
